import React from "react";
import { useNavigate } from "react-router-dom";
import successCheckMark from "../../assets/images/successNewIcon.svg";
import * as ROUTES from "../../constants/routes";
import { NewModal } from "../uiMerge/newModal";
import NewButton from "../uiMerge/newButton";

interface ChangePasswordConfirmationModalProps {
  visible: boolean;
  onCancel: () => void;
}

export const ChangePasswordConfirmationModal: React.FC<ChangePasswordConfirmationModalProps> = ({
  visible,
  onCancel,
}) => {
  const navigate = useNavigate();

  return (
    <NewModal
      isOpen={visible}
      heightClass="h-[351px]"
      showCloseButton={false}
      position="end"
      animationClass="grow-in"
      colorClass="bg-black"
      onClose={onCancel}
    >
      <div className="w-full flex flex-col justify-center items-center py-6 px-[1rem]">
        <div className="flex flex-col justify-center gap-5 items-center">
          <div>
            <img
              src={successCheckMark}
              alt="Reset Successful"
              width={63}
              height={63}
            />
          </div>

          <div className="text-white text-center text-2xl mt-4 mb-6">
            <p>Your Password Has Successfully Been Changed.</p>
          </div>

          <NewButton
            fullWidth
            variant="primary"
            onClick={() => navigate(ROUTES.LOGIN)}
          >
            Go to Login
          </NewButton>
        </div>
      </div>
    </NewModal>
  );
};